export const environment = {
  production: true,
  apiSite:'https://live.twininspections.com/',
  api:'https://live.twininspections.com/api/',
  oldSite:'https://twininspections.com/',
  doSpace:'https://twin-inspections-media.nyc3.digitaloceanspaces.com',
appDashboard:'ISM',
inspectionReports : true
};
